import { sendMessageAction } from './actions';

export default ({ message, conversationId }) => (dispatch, _, { apiV2 }) => {
  dispatch(sendMessageAction.start());

  return apiV2
    .sendMessage(
      conversationId,
      { messageText: message },
      { expand: 'messages' },
    )
    .then(({ data }) => dispatch(sendMessageAction.done(data.messages)))
    .catch(error => dispatch(sendMessageAction.error(error)));
};
